import React, { useEffect, useState } from "react";
import "./shiftInfoBox.scss";

import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";

import { t } from "i18next";
import { Button, Col, Row, Stack } from "react-bootstrap";
import {
  removeUserSubscritpionWS,
  subscriptionShiftWS,
} from "./api/shiftInfoBoxApi";
import { gestioneSnackbar } from "../../utils/common";
import moment from "moment";
import { isEmpty } from "../../utils/validation";
import CustomDialog from "../customDialog/CustomDialog";
import { useNavigate } from "react-router-dom";

const ShiftInfoBox = ({
  id,
  title,
  description,
  startDatetime,
  endDatetime,
  qta,
  iAmSubscribed,
  qtaAvailable,
  eventTerminated,
  isAdmin = false,
  viewButtonSubscription = true,
  pathOnClickIsAdmin,
}) => {
  const navigate = useNavigate();

  const [iAmSubscribedState, setIAmSubscribedState] = useState(false);
  const [viewDescription, setViewDescription] = useState(false);
  useEffect(() => {
    setIAmSubscribedState(iAmSubscribed);
  }, []);

  const handleClickSubscribed = (id_shift) => {
    if (iAmSubscribedState) {
      //Sono già iscritto e confermato quindi posso disiscrivermi
      removeUserSubscritpionWS({ id_shift })
        .then((res) => {
          gestioneSnackbar(true, res.message, "success");
          setIAmSubscribedState(false);
        })
        .catch((err) => {
          gestioneSnackbar(true, err.message, "error");
        });
    } else {
      // Devo iscrivermi quindi devo fare un po' di controlli
      if (eventTerminated) {
        //Evento già terminato
        return gestioneSnackbar(
          true,
          t("event.subscription_to_terminated_event"),
          "error"
        );
      }
      if (qtaAvailable === 0) {
        // Posti finiti
        return gestioneSnackbar(
          true,
          t("event.subscription_not_available_spots"),
          "error"
        );
      }

      const now = moment();
      if (moment(endDatetime, "DD/MM/YYYY HH:mm").isBefore(now) === true) {
        //Se la data di fine è già stata superata allora non posso iscrivermi
        return gestioneSnackbar(
          true,
          t("event.shift_already_terminated"),
          "error"
        );
      }

      subscriptionShiftWS({ id_shift })
        .then((res) => {
          gestioneSnackbar(true, res.message, "success");
        })
        .catch((err) => {
          gestioneSnackbar(true, err.message, "error");
        });
    }
  };

  return (
    <Stack
      direction="vertical"
      gap={2}
      className="shift-info-box-container"
      style={{ cursor: isAdmin ? "pointer" : null }}
      onClick={() => {
        if (isAdmin) navigate(pathOnClickIsAdmin);
      }}
    >
      {title ? (
        <Stack direction="vertical" gap={1}>
          <Stack
            direction="horizontal"
            className="d-flex justify-content-between align-items-center"
          >
            <span className="title-shift">{title}</span>
            {isAdmin ? (
              <Button
                variant="info"
                onClick={(e) => {
                  e.stopPropagation();
                  if (isAdmin) navigate(pathOnClickIsAdmin);
                }}
                className="view-description-button"
              >
                {t(
                  viewDescription
                    ? "common.less_details"
                    : "common.more_details"
                )}
              </Button>
            ) : null}
            {!isAdmin && !isEmpty(description) ? (
              <Button
                variant="info"
                onClick={(e) => {
                  e.stopPropagation();
                  setViewDescription(!viewDescription);
                }}
                className="view-description-button"
              >
                {t(
                  viewDescription
                    ? "common.less_details"
                    : "common.more_details"
                )}
              </Button>
            ) : null}
          </Stack>
          {viewDescription ? (
            <p className="description-shift">{description}</p>
          ) : null}
        </Stack>
      ) : null}

      <div className="details-shift-container">
        <Row>
          <Col className="d-flex flex-1">
            <Stack
              direction="vertical"
              className="d-flex justify-content-center"
            >
              <div className="date-shift">
                {t("common.from_date")} {startDatetime}
              </div>
              <div className="date-shift">
                {t("common.to_date")} {endDatetime}
              </div>
            </Stack>
          </Col>
          <Col className="shift-right-column">
            <Stack
              direction="horizontal"
              gap={2}
              className="d-flex justify-content-between align-items-center flex-1 "
            >
              <span>
                {t("event.n_available_volunteers", { number: qtaAvailable })}
              </span>
              {viewButtonSubscription ? (
                !iAmSubscribedState ? (
                  <Button
                    variant="success"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClickSubscribed(id);
                    }}
                  >
                    <PersonAddAlt1Icon /> {t("common.follow")}
                  </Button>
                ) : (
                  <CustomDialog
                    title={t("event.title_modal_unsubscribed_shift")}
                    body={t("event.body_modal_unsubcribed_shift")}
                    callback={() => {
                      handleClickSubscribed(id);
                    }}
                    trigger={
                      <Button variant="info" size="sm">
                        <DoneAllOutlinedIcon /> {t("common.already_subscribed")}
                      </Button>
                    }
                  />
                )
              ) : null}
            </Stack>
          </Col>
        </Row>
      </div>
    </Stack>
  );
};

export default ShiftInfoBox;
